import { __read } from "tslib";
import EdgeworthIcon from '@office-start/edgeworth-icon';
import { QuickAccessIcon, } from '@office-start/quick-access-icon';
import classNames from 'classnames';
import React, { forwardRef, useCallback, useEffect, useMemo, useState, } from 'react';
import styles from './PillControl.module.scss';
export var PillControl = forwardRef(function (_a, ref) {
    var _b, _c, _d;
    var id = _a.id, title = _a.title, onClick = _a.onClick, isActive = _a.isActive, iconName = _a.iconName, iconElement = _a.iconElement, iconElementActive = _a.iconElementActive, isDropdown = _a.isDropdown, isRemovable = _a.isRemovable, isStatic = _a.isStatic, onRemoveClick = _a.onRemoveClick, disableFocus = _a.disableFocus, style = _a.style, pillTextStyle = _a.pillTextStyle, ariaLabel = _a.ariaLabel, ariaDescribedbyId = _a.ariaDescribedbyId, removePillAriaLabel = _a.removePillAriaLabel, onKeyDown = _a.onKeyDown, disableRemoveFocus = _a.disableRemoveFocus;
    var wrappedOnRemoveClick = useCallback(function (event) {
        event === null || event === void 0 ? void 0 : event.stopPropagation();
        if (onRemoveClick) {
            onRemoveClick();
        }
    }, [onRemoveClick]);
    var _e = __read(useState(), 2), resolvedIconElement = _e[0], setResolvedIconElement = _e[1];
    var _f = __read(useState(), 2), resolvedIconElementActive = _f[0], setResolvedIconElementActive = _f[1];
    useEffect(function () {
        if (iconElement) {
            Promise.resolve(iconElement).then(setResolvedIconElement);
        }
    }, [iconElement]);
    useEffect(function () {
        if (iconElementActive) {
            Promise.resolve(iconElementActive).then(setResolvedIconElementActive);
        }
    }, [iconElementActive]);
    var isDropdownPillStyle = isDropdown && iconName;
    var pillIcon = useMemo(function () {
        var _a, _b, _c;
        return resolvedIconElementActive && isActive ? (React.createElement("div", { className: classNames(styles['icon'], (_a = {},
                _a[styles['icon--active']] = !isDropdownPillStyle,
                _a)) }, resolvedIconElementActive)) : resolvedIconElement ? (React.createElement("div", { className: classNames(styles['icon'], (_b = {},
                _b[styles['icon--active']] = isActive && !isDropdownPillStyle,
                _b)) }, resolvedIconElement)) : iconName ? (React.createElement(QuickAccessIcon, { className: classNames(styles['icon'], (_c = {},
                _c[styles['icon--active']] = isActive && !isDropdownPillStyle,
                _c)), iconName: "".concat(iconName).concat(isActive ? 'Active' : '') })) : null;
    }, [
        iconName,
        isActive,
        isDropdownPillStyle,
        resolvedIconElement,
        resolvedIconElementActive,
    ]);
    var pillText = useMemo(function () {
        var _a;
        return (React.createElement("span", { className: classNames(styles['pill-text'], (_a = {},
                _a[styles['pill-text--active']] = isActive && !isDropdownPillStyle,
                _a[styles['pill-text--static']] = isStatic,
                _a)) },
            React.createElement("div", { className: styles['pill-text--fake'], title: title, style: pillTextStyle }, title)));
    }, [isActive, isDropdownPillStyle, isStatic, pillTextStyle, title]);
    var dropdownIcon = useMemo(function () {
        return (React.createElement(QuickAccessIcon, { className: styles['dropdown'], iconName: isActive
                ? 'ChevronDownActive'
                : 'ChevronDown' }));
    }, [isActive]);
    //Render pill as span if it does not need interactivity
    return !onClick && !onRemoveClick && !onKeyDown ? (React.createElement("span", { id: id, className: classNames(styles['pill'], (_b = {},
            _b[styles['pill--active']] = isActive,
            _b[styles['pill--static']] = isStatic,
            _b[styles['pill--dropdown']] = isDropdownPillStyle,
            _b[styles['pill--dropdown--active']] = isDropdownPillStyle && isActive,
            _b)), "data-clicklog": "custom", style: style, "aria-label": ariaLabel, tabIndex: !disableFocus ? 0 : undefined, "aria-hidden": disableFocus, "aria-describedby": ariaDescribedbyId },
        pillIcon,
        pillText,
        isDropdown && dropdownIcon)) : (React.createElement("button", { id: id, ref: ref, onClick: onClick, onKeyDown: function (event) {
            event.stopPropagation();
            onKeyDown && onKeyDown(event, id);
        }, className: classNames(styles['pill'], (_c = {},
            _c[styles['pill--active']] = isActive,
            _c[styles['pill--static']] = isStatic,
            _c[styles['pill--dropdown']] = isDropdownPillStyle,
            _c[styles['pill--dropdown--active']] = isDropdownPillStyle && isActive,
            _c)), tabIndex: disableFocus ? -1 : 0, "data-clicklog": "custom", style: style, "aria-label": ariaLabel, "aria-describedby": ariaDescribedbyId },
        pillIcon,
        pillText,
        isDropdown && dropdownIcon,
        isRemovable ? (React.createElement("div", { className: classNames(styles['remove'], (_d = {},
                _d[styles['remove--active']] = isActive,
                _d[styles['remove--static']] = isStatic,
                _d)), onClick: wrappedOnRemoveClick, onKeyDown: function (event) {
                event.stopPropagation();
                if (event.key === 'Enter' ||
                    event.key === 'Space') {
                    event.preventDefault();
                    wrappedOnRemoveClick(event);
                }
            }, "aria-hidden": false, "aria-label": removePillAriaLabel, role: disableRemoveFocus ? 'none' : 'button', tabIndex: disableRemoveFocus ? -1 : 0 },
            React.createElement(EdgeworthIcon, { iconName: "SmallDismissIcon" }))) : null));
});
PillControl.displayName = 'PillControl';
//# sourceMappingURL=PillControl.js.map